// Handlers
import { initialisePushSubscription } from './notifications/push/pushNotificationsManager';

// Utils
import logger from './utils/logger';
import { getIsHybridApp } from './hybridApp/hybridAppUtils';
import { sendAmplitudeEvent } from './analytics/amplitudeService';

// For now disabling the service worker on Electron and the iPad app as it doesn't work correctly
export const getIsServiceWorkerAvailable = () => 'serviceWorker' in navigator && !getIsHybridApp();

const registerServiceWorker = (store) => {
    // Scope is optional here as it will default to the sub-directory of the service worker file
    navigator.serviceWorker
        .register('/sw.js', { scope: '/' })
        .then((reg) => {
            logger.info('%cSW: Registration - successfully registered', 'color: green', reg);
            initialisePushSubscription(store);
        })
        .catch((err) => {
            logger.error('SW: Registration - registration failed', err);
        });
};

export default (store) => {
    if (!getIsServiceWorkerAvailable()) {
        logger.warn('SW: Registration - not available in this browser');
        return;
    }

    logger.info('%cSW: Registration - available and will be registered', 'color: blue');
    registerServiceWorker(store);
};

let beforeInstallEvent = null;

window.addEventListener('beforeinstallprompt', async (event) => {
    event.preventDefault();
    logger.info('%cSW: Install: capturing install prompt', 'color: green');
    beforeInstallEvent = event;
});

export const getPwaInstallEvent = () => beforeInstallEvent;
export const clearPwaInstallEvent = () => {
    beforeInstallEvent = null;
};

window.addEventListener('appinstalled', () => {
    sendAmplitudeEvent({ eventType: 'Installed PWA' });
});
